/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useContext, useState, useRef } from 'react'
import { connect } from 'react-redux'
import { DatePicker, Button, Upload, Icon, Input, message, Tabs } from 'antd'
import moment from 'moment'
import Grid, { virtualizedGridRenderer } from '@integec/grid-tools'
import { strCol, dateTimeCol } from '@integec/grid-tools/lib/cols'
import {
  rowHeaderRender,
  hasAccesPermits,
  exportDataComponent,
} from 'core/utils'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'

import { DatePickerContext, SpinContext, ErrorContext } from 'context'
import {
  getEnvConfig,
  getPermitActions,
  getApiTargetInfo,
  ExportComponent,
} from 'core'
import * as ScreenPermissions from 'core/EventActions'
import { CriteriaRow, Title, FullHeightSizer, Content } from 'core/screen-util'
import { getGHWPImport, getAuthorization, getCredentials } from 'api/pgads.js'
import JcTmpErrorDialog from 'core/component/JcTmpErrorDialog'

const GhwpContactImportHeaders = [
  dateTimeCol({
    ident: 'pctimestamp',
    display: 'Pctimestamp',
    isKey: true,
    width: 200,
  }),
  strCol({ ident: 't001A', display: 'T001A', isFiltered: true }),
  strCol({ ident: 't002A', display: 'T002A', isFiltered: true }),
  strCol({ ident: 't003A', display: 'T003A', isFiltered: true }),
  strCol({ ident: 't004A', display: 'T004A', isFiltered: true }),
  strCol({ ident: 't007A', display: 'T007A', isFiltered: true }),
  strCol({ ident: 't008A', display: 'T008A', isFiltered: true }),
  strCol({ ident: 't009A', display: 'T009A', isFiltered: true }),
  strCol({ ident: 't010A', display: 'T010A', isFiltered: true }),
  strCol({ ident: 't011A', display: 'T011A', isFiltered: true }),
  strCol({ ident: 't012A', display: 'T012A', isFiltered: true }),
  strCol({ ident: 't013A', display: 'T013A', isFiltered: true }),
  strCol({ ident: 't014A', display: 'T014A', isFiltered: true }),
  strCol({ ident: 't015A', display: 'T015A', isFiltered: true }),
  strCol({ ident: 't016A', display: 'T016A', isFiltered: true }),
  strCol({ ident: 't017A', display: 'T017A', isFiltered: true }),
  strCol({ ident: 't018A', display: 'T018A', isFiltered: true }),
  strCol({ ident: 't019A', display: 'T019A', isFiltered: true }),
  strCol({ ident: 't020A', display: 'T020A', isFiltered: true }),
  strCol({ ident: 't021A', display: 'T021A', isFiltered: true }),
  strCol({ ident: 't022A', display: 'T022A', isFiltered: true }),
  strCol({ ident: 't023A', display: 'T023A', isFiltered: true }),
  strCol({ ident: 't024A', display: 'T024A', isFiltered: true }),
  strCol({ ident: 't025A', display: 'T025A', isFiltered: true }),
  strCol({ ident: 't027A', display: 'T027A', isFiltered: true }),
  strCol({ ident: 't028A', display: 'T028A', isFiltered: true }),
  strCol({ ident: 't029A', display: 'T029A', isFiltered: true }),
  strCol({ ident: 't030A', display: 'T030A', isFiltered: true }),
  strCol({ ident: 't031A', display: 'T031A', isFiltered: true }),
  strCol({ ident: 't032A', display: 'T032A', isFiltered: true }),
  strCol({ ident: 't033A', display: 'T033A', isFiltered: true }),
  strCol({ ident: 't034A', display: 'T034A', isFiltered: true }),
  strCol({ ident: 't035A', display: 'T035A', isFiltered: true }),
  strCol({ ident: 't038A', display: 'T038A', isFiltered: true }),
  strCol({ ident: 't040A', display: 'T040A', isFiltered: true }),
  strCol({ ident: 't042A', display: 'T042A', isFiltered: true }),
  strCol({ ident: 't043A', display: 'T043A', isFiltered: true }),
  strCol({ ident: 't044A', display: 'T044A', isFiltered: true }),
  strCol({ ident: 't045A', display: 'T045A', isFiltered: true }),
  strCol({ ident: 't047A', display: 'T047A', isFiltered: true }),
  strCol({ ident: 't048A', display: 'T048A', isFiltered: true }),
  strCol({ ident: 't049A', display: 'T049A', isFiltered: true }),
  strCol({ ident: 't050A', display: 'T050A', isFiltered: true }),
  strCol({ ident: 't053A', display: 'T053A', isFiltered: true }),
  strCol({ ident: 't055A', display: 'T055A', isFiltered: true }),
  strCol({ ident: 't056A', display: 'T056A', isFiltered: true }),
  strCol({ ident: 't057A', display: 'T057A', isFiltered: true }),
  strCol({ ident: 't058A', display: 'T058A', isFiltered: true }),
  strCol({ ident: 't059A', display: 'T059A', isFiltered: true }),
  strCol({ ident: 't060A', display: 'T060A', isFiltered: true }),
  strCol({ ident: 't061A', display: 'T061A', isFiltered: true }),
  strCol({ ident: 't062A', display: 'T062A', isFiltered: true }),
  strCol({ ident: 't063A', display: 'T063A', isFiltered: true }),
  strCol({ ident: 't064A', display: 'T064A', isFiltered: true }),
  strCol({ ident: 't065A', display: 'T065A', isFiltered: true }),
  strCol({ ident: 't066A', display: 'T066A', isFiltered: true }),
  strCol({ ident: 't067A', display: 'T067A', isFiltered: true }),
  strCol({ ident: 't068A', display: 'T068A', isFiltered: true }),
  strCol({ ident: 't070A', display: 'T070A', isFiltered: true }),
  strCol({ ident: 't071A', display: 'T071A', isFiltered: true }),
  strCol({ ident: 't072A', display: 'T072A', isFiltered: true }),
  strCol({ ident: 't073A', display: 'T073A', isFiltered: true }),
  strCol({ ident: 't074A', display: 'T074A', isFiltered: true }),
  strCol({ ident: 't076A', display: 'T076A', isFiltered: true }),
  strCol({ ident: 't077A', display: 'T077A', isFiltered: true }),
  strCol({ ident: 't078A', display: 'T078A', isFiltered: true }),
  strCol({ ident: 't079A', display: 'T079A', isFiltered: true }),
  strCol({ ident: 't080A', display: 'T080A', isFiltered: true }),
  strCol({ ident: 't081A', display: 'T081A', isFiltered: true }),
  strCol({ ident: 't083A', display: 'T083A', isFiltered: true }),
  strCol({ ident: 't084A', display: 'T084A', isFiltered: true }),
  strCol({ ident: 't085A', display: 'T085A', isFiltered: true }),
  strCol({ ident: 't086A', display: 'T086A', isFiltered: true }),
  strCol({ ident: 't087A', display: 'T087A', isFiltered: true }),
  strCol({ ident: 't089A', display: 'T089A', isFiltered: true }),
  strCol({ ident: 't091A', display: 'T091A', isFiltered: true }),
  strCol({ ident: 't092A', display: 'T092A', isFiltered: true }),
  strCol({ ident: 't095A', display: 'T095A', isFiltered: true }),
  strCol({ ident: 't096A', display: 'T096A', isFiltered: true }),
  strCol({ ident: 't100A', display: 'T100A', isFiltered: true }),
  strCol({ ident: 't106A', display: 'T106A', isFiltered: true }),
  strCol({ ident: 't107A', display: 'T107A', isFiltered: true }),
  strCol({ ident: 't111A', display: 'T111A', isFiltered: true }),
  strCol({ ident: 't112A', display: 'T112A', isFiltered: true }),
  strCol({ ident: 't117A', display: 'T117A', isFiltered: true }),
  strCol({ ident: 't120A', display: 'T120A', isFiltered: true }),
  strCol({ ident: 't121A', display: 'T121A', isFiltered: true }),
  strCol({ ident: 't123A', display: 'T123A', isFiltered: true }),
  strCol({ ident: 't124A', display: 'T124A', isFiltered: true }),
  strCol({ ident: 't135A', display: 'T135A', isFiltered: true }),
  strCol({ ident: 't136A', display: 'T136A', isFiltered: true }),
  strCol({ ident: 't001B', display: 'T001B', isFiltered: true }),
  strCol({ ident: 't002B', display: 'T002B', isFiltered: true }),
  strCol({ ident: 't003B', display: 'T003B', isFiltered: true }),
  strCol({ ident: 't004B', display: 'T004B', isFiltered: true }),
  strCol({ ident: 't007B', display: 'T007B', isFiltered: true }),
  strCol({ ident: 't008B', display: 'T008B', isFiltered: true }),
  strCol({ ident: 't009B', display: 'T009B', isFiltered: true }),
  strCol({ ident: 't010B', display: 'T010B', isFiltered: true }),
  strCol({ ident: 't011B', display: 'T011B', isFiltered: true }),
  strCol({ ident: 't012B', display: 'T012B', isFiltered: true }),
  strCol({ ident: 't013B', display: 'T013B', isFiltered: true }),
  strCol({ ident: 't014B', display: 'T014B', isFiltered: true }),
  strCol({ ident: 't015B', display: 'T015B', isFiltered: true }),
  strCol({ ident: 't016B', display: 'T016B', isFiltered: true }),
  strCol({ ident: 't017B', display: 'T017B', isFiltered: true }),
  strCol({ ident: 't018B', display: 'T018B', isFiltered: true }),
  strCol({ ident: 't019B', display: 'T019B', isFiltered: true }),
  strCol({ ident: 't020B', display: 'T020B', isFiltered: true }),
  strCol({ ident: 't021B', display: 'T021B', isFiltered: true }),
  strCol({ ident: 't022B', display: 'T022B', isFiltered: true }),
  strCol({ ident: 't023B', display: 'T023B', isFiltered: true }),
  strCol({ ident: 't024B', display: 'T024B', isFiltered: true }),
  strCol({ ident: 't025B', display: 'T025B', isFiltered: true }),
  strCol({ ident: 't027B', display: 'T027B', isFiltered: true }),
  strCol({ ident: 't028B', display: 'T028B', isFiltered: true }),
  strCol({ ident: 't029B', display: 'T029B', isFiltered: true }),
  strCol({ ident: 't030B', display: 'T030B', isFiltered: true }),
  strCol({ ident: 't031B', display: 'T031B', isFiltered: true }),
  strCol({ ident: 't032B', display: 'T032B', isFiltered: true }),
  strCol({ ident: 't033B', display: 'T033B', isFiltered: true }),
  strCol({ ident: 't034B', display: 'T034B', isFiltered: true }),
  strCol({ ident: 't035B', display: 'T035B', isFiltered: true }),
  strCol({ ident: 't038B', display: 'T038B', isFiltered: true }),
  strCol({ ident: 't040B', display: 'T040B', isFiltered: true }),
  strCol({ ident: 't042B', display: 'T042B', isFiltered: true }),
  strCol({ ident: 't043B', display: 'T043B', isFiltered: true }),
  strCol({ ident: 't044B', display: 'T044B', isFiltered: true }),
  strCol({ ident: 't045B', display: 'T045B', isFiltered: true }),
  strCol({ ident: 't047B', display: 'T047B', isFiltered: true }),
  strCol({ ident: 't048B', display: 'T048B', isFiltered: true }),
  strCol({ ident: 't049B', display: 'T049B', isFiltered: true }),
  strCol({ ident: 't050B', display: 'T050B', isFiltered: true }),
  strCol({ ident: 't053B', display: 'T053B', isFiltered: true }),
  strCol({ ident: 't055B', display: 'T055B', isFiltered: true }),
  strCol({ ident: 't056B', display: 'T056B', isFiltered: true }),
  strCol({ ident: 't057B', display: 'T057B', isFiltered: true }),
  strCol({ ident: 't058B', display: 'T058B', isFiltered: true }),
  strCol({ ident: 't059B', display: 'T059B', isFiltered: true }),
  strCol({ ident: 't060B', display: 'T060B', isFiltered: true }),
  strCol({ ident: 't061B', display: 'T061B', isFiltered: true }),
  strCol({ ident: 't062B', display: 'T062B', isFiltered: true }),
  strCol({ ident: 't063B', display: 'T063B', isFiltered: true }),
  strCol({ ident: 't064B', display: 'T064B', isFiltered: true }),
  strCol({ ident: 't065B', display: 'T065B', isFiltered: true }),
  strCol({ ident: 't066B', display: 'T066B', isFiltered: true }),
  strCol({ ident: 't067B', display: 'T067B', isFiltered: true }),
  strCol({ ident: 't068B', display: 'T068B', isFiltered: true }),
  strCol({ ident: 't070B', display: 'T070B', isFiltered: true }),
  strCol({ ident: 't071B', display: 'T071B', isFiltered: true }),
  strCol({ ident: 't072B', display: 'T072B', isFiltered: true }),
  strCol({ ident: 't073B', display: 'T073B', isFiltered: true }),
  strCol({ ident: 't074B', display: 'T074B', isFiltered: true }),
  strCol({ ident: 't076B', display: 'T076B', isFiltered: true }),
  strCol({ ident: 't077B', display: 'T077B', isFiltered: true }),
  strCol({ ident: 't078B', display: 'T078B', isFiltered: true }),
  strCol({ ident: 't079B', display: 'T079B', isFiltered: true }),
  strCol({ ident: 't080B', display: 'T080B', isFiltered: true }),
  strCol({ ident: 't081B', display: 'T081B', isFiltered: true }),
  strCol({ ident: 't083B', display: 'T083B', isFiltered: true }),
  strCol({ ident: 't084B', display: 'T084B', isFiltered: true }),
  strCol({ ident: 't085B', display: 'T085B', isFiltered: true }),
  strCol({ ident: 't086B', display: 'T086B', isFiltered: true }),
  strCol({ ident: 't087B', display: 'T087B', isFiltered: true }),
  strCol({ ident: 't089B', display: 'T089B', isFiltered: true }),
  strCol({ ident: 't091B', display: 'T091B', isFiltered: true }),
  strCol({ ident: 't092B', display: 'T092B', isFiltered: true }),
  strCol({ ident: 't095B', display: 'T095B', isFiltered: true }),
  strCol({ ident: 't096B', display: 'T096B', isFiltered: true }),
  strCol({ ident: 't100B', display: 'T100B', isFiltered: true }),
  strCol({ ident: 't106B', display: 'T106B', isFiltered: true }),
  strCol({ ident: 't107B', display: 'T107B', isFiltered: true }),
  strCol({ ident: 't111B', display: 'T111B', isFiltered: true }),
  strCol({ ident: 't112B', display: 'T112B', isFiltered: true }),
  strCol({ ident: 't117B', display: 'T117B', isFiltered: true }),
  strCol({ ident: 't120B', display: 'T120B', isFiltered: true }),
  strCol({ ident: 't121B', display: 'T121B', isFiltered: true }),
  strCol({ ident: 't123B', display: 'T123B', isFiltered: true }),
  strCol({ ident: 't124B', display: 'T124B', isFiltered: true }),
  strCol({ ident: 't135B', display: 'T135B', isFiltered: true }),
  strCol({ ident: 't136B', display: 'T136B', isFiltered: true }),
  modifierCol,
  modifiedDateCol,
]

const Ghwp10minImportHeaders = [
  dateTimeCol({
    ident: 'pctimestamp',
    display: 'Pctimestamp',
    isKey: true,
    width: 200,
  }),
  strCol({ ident: 't001AlarmNo', display: 'T001 AlarmNo', isFiltered: true }),
  strCol({ ident: 't002AlarmNo', display: 'T002 AlarmNo', isFiltered: true }),
  strCol({ ident: 't003AlarmNo', display: 'T003 AlarmNo', isFiltered: true }),
  strCol({ ident: 't004AlarmNo', display: 'T004 AlarmNo', isFiltered: true }),
  strCol({ ident: 't007AlarmNo', display: 'T007 AlarmNo', isFiltered: true }),
  strCol({ ident: 't008AlarmNo', display: 'T008 AlarmNo', isFiltered: true }),
  strCol({ ident: 't009AlarmNo', display: 'T009 AlarmNo', isFiltered: true }),
  strCol({ ident: 't010AlarmNo', display: 'T010 AlarmNo', isFiltered: true }),
  strCol({ ident: 't011AlarmNo', display: 'T011 AlarmNo', isFiltered: true }),
  strCol({ ident: 't012AlarmNo', display: 'T012 AlarmNo', isFiltered: true }),
  strCol({ ident: 't013AlarmNo', display: 'T013 AlarmNo', isFiltered: true }),
  strCol({ ident: 't014AlarmNo', display: 'T014 AlarmNo', isFiltered: true }),
  strCol({ ident: 't015AlarmNo', display: 'T015 AlarmNo', isFiltered: true }),
  strCol({ ident: 't016AlarmNo', display: 'T016 AlarmNo', isFiltered: true }),
  strCol({ ident: 't017AlarmNo', display: 'T017 AlarmNo', isFiltered: true }),
  strCol({ ident: 't018AlarmNo', display: 'T018 AlarmNo', isFiltered: true }),
  strCol({ ident: 't019AlarmNo', display: 'T019 AlarmNo', isFiltered: true }),
  strCol({ ident: 't020AlarmNo', display: 'T020 AlarmNo', isFiltered: true }),
  strCol({ ident: 't021AlarmNo', display: 'T021 AlarmNo', isFiltered: true }),
  strCol({ ident: 't022AlarmNo', display: 'T022 AlarmNo', isFiltered: true }),
  strCol({ ident: 't023AlarmNo', display: 'T023 AlarmNo', isFiltered: true }),
  strCol({ ident: 't024AlarmNo', display: 'T024 AlarmNo', isFiltered: true }),
  strCol({ ident: 't025AlarmNo', display: 'T025 AlarmNo', isFiltered: true }),
  strCol({ ident: 't027AlarmNo', display: 'T027 AlarmNo', isFiltered: true }),
  strCol({ ident: 't028AlarmNo', display: 'T028 AlarmNo', isFiltered: true }),
  strCol({ ident: 't029AlarmNo', display: 'T029 AlarmNo', isFiltered: true }),
  strCol({ ident: 't030AlarmNo', display: 'T030 AlarmNo', isFiltered: true }),
  strCol({ ident: 't031AlarmNo', display: 'T031 AlarmNo', isFiltered: true }),
  strCol({ ident: 't032AlarmNo', display: 'T032 AlarmNo', isFiltered: true }),
  strCol({ ident: 't033AlarmNo', display: 'T033 AlarmNo', isFiltered: true }),
  strCol({ ident: 't034AlarmNo', display: 'T034 AlarmNo', isFiltered: true }),
  strCol({ ident: 't035AlarmNo', display: 'T035 AlarmNo', isFiltered: true }),
  strCol({ ident: 't038AlarmNo', display: 'T038 AlarmNo', isFiltered: true }),
  strCol({ ident: 't040AlarmNo', display: 'T040 AlarmNo', isFiltered: true }),
  strCol({ ident: 't042AlarmNo', display: 'T042 AlarmNo', isFiltered: true }),
  strCol({ ident: 't043AlarmNo', display: 'T043 AlarmNo', isFiltered: true }),
  strCol({ ident: 't044AlarmNo', display: 'T044 AlarmNo', isFiltered: true }),
  strCol({ ident: 't045AlarmNo', display: 'T045 AlarmNo', isFiltered: true }),
  strCol({ ident: 't047AlarmNo', display: 'T047 AlarmNo', isFiltered: true }),
  strCol({ ident: 't048AlarmNo', display: 'T048 AlarmNo', isFiltered: true }),
  strCol({ ident: 't049AlarmNo', display: 'T049 AlarmNo', isFiltered: true }),
  strCol({ ident: 't050AlarmNo', display: 'T050 AlarmNo', isFiltered: true }),
  strCol({ ident: 't053AlarmNo', display: 'T053 AlarmNo', isFiltered: true }),
  strCol({ ident: 't055AlarmNo', display: 'T055 AlarmNo', isFiltered: true }),
  strCol({ ident: 't056AlarmNo', display: 'T056 AlarmNo', isFiltered: true }),
  strCol({ ident: 't057AlarmNo', display: 'T057 AlarmNo', isFiltered: true }),
  strCol({ ident: 't058AlarmNo', display: 'T058 AlarmNo', isFiltered: true }),
  strCol({ ident: 't059AlarmNo', display: 'T059 AlarmNo', isFiltered: true }),
  strCol({ ident: 't060AlarmNo', display: 'T060 AlarmNo', isFiltered: true }),
  strCol({ ident: 't061AlarmNo', display: 'T061 AlarmNo', isFiltered: true }),
  strCol({ ident: 't062AlarmNo', display: 'T062 AlarmNo', isFiltered: true }),
  strCol({ ident: 't063AlarmNo', display: 'T063 AlarmNo', isFiltered: true }),
  strCol({ ident: 't064AlarmNo', display: 'T064 AlarmNo', isFiltered: true }),
  strCol({ ident: 't065AlarmNo', display: 'T065 AlarmNo', isFiltered: true }),
  strCol({ ident: 't066AlarmNo', display: 'T066 AlarmNo', isFiltered: true }),
  strCol({ ident: 't067AlarmNo', display: 'T067 AlarmNo', isFiltered: true }),
  strCol({ ident: 't068AlarmNo', display: 'T068 AlarmNo', isFiltered: true }),
  strCol({ ident: 't070AlarmNo', display: 'T070 AlarmNo', isFiltered: true }),
  strCol({ ident: 't071AlarmNo', display: 'T071 AlarmNo', isFiltered: true }),
  strCol({ ident: 't072AlarmNo', display: 'T072 AlarmNo', isFiltered: true }),
  strCol({ ident: 't073AlarmNo', display: 'T073 AlarmNo', isFiltered: true }),
  strCol({ ident: 't074AlarmNo', display: 'T074 AlarmNo', isFiltered: true }),
  strCol({ ident: 't076AlarmNo', display: 'T076 AlarmNo', isFiltered: true }),
  strCol({ ident: 't077AlarmNo', display: 'T077 AlarmNo', isFiltered: true }),
  strCol({ ident: 't078AlarmNo', display: 'T078 AlarmNo', isFiltered: true }),
  strCol({ ident: 't079AlarmNo', display: 'T079 AlarmNo', isFiltered: true }),
  strCol({ ident: 't080AlarmNo', display: 'T080 AlarmNo', isFiltered: true }),
  strCol({ ident: 't081AlarmNo', display: 'T081 AlarmNo', isFiltered: true }),
  strCol({ ident: 't083AlarmNo', display: 'T083 AlarmNo', isFiltered: true }),
  strCol({ ident: 't084AlarmNo', display: 'T084 AlarmNo', isFiltered: true }),
  strCol({ ident: 't085AlarmNo', display: 'T085 AlarmNo', isFiltered: true }),
  strCol({ ident: 't086AlarmNo', display: 'T086 AlarmNo', isFiltered: true }),
  strCol({ ident: 't087AlarmNo', display: 'T087 AlarmNo', isFiltered: true }),
  strCol({ ident: 't089AlarmNo', display: 'T089 AlarmNo', isFiltered: true }),
  strCol({ ident: 't091AlarmNo', display: 'T091 AlarmNo', isFiltered: true }),
  strCol({ ident: 't092AlarmNo', display: 'T092 AlarmNo', isFiltered: true }),
  strCol({ ident: 't095AlarmNo', display: 'T095 AlarmNo', isFiltered: true }),
  strCol({ ident: 't096AlarmNo', display: 'T096 AlarmNo', isFiltered: true }),
  strCol({ ident: 't100AlarmNo', display: 'T100 AlarmNo', isFiltered: true }),
  strCol({ ident: 't106AlarmNo', display: 'T106 AlarmNo', isFiltered: true }),
  strCol({ ident: 't107AlarmNo', display: 'T107 AlarmNo', isFiltered: true }),
  strCol({ ident: 't111AlarmNo', display: 'T111 AlarmNo', isFiltered: true }),
  strCol({ ident: 't112AlarmNo', display: 'T112 AlarmNo', isFiltered: true }),
  strCol({ ident: 't117AlarmNo', display: 'T117 AlarmNo', isFiltered: true }),
  strCol({ ident: 't120AlarmNo', display: 'T120 AlarmNo', isFiltered: true }),
  strCol({ ident: 't121AlarmNo', display: 'T121 AlarmNo', isFiltered: true }),
  strCol({ ident: 't123AlarmNo', display: 'T123 AlarmNo', isFiltered: true }),
  strCol({ ident: 't124AlarmNo', display: 'T124 AlarmNo', isFiltered: true }),
  strCol({ ident: 't135AlarmNo', display: 'T135 AlarmNo', isFiltered: true }),
  strCol({ ident: 't136AlarmNo', display: 'T136 AlarmNo', isFiltered: true }),
  modifierCol,
  modifiedDateCol,
]

const GHWPImport = ({ apiTargetInfo, envConfig, actionPermits }) => {
  const [mwImportData, setMwImportData] = useState({})
  const [fuzzyFilter, setFuzzyFilter] = useState(null)
  const [showMessages, setShowMessages] = useState(false)
  const [messages, setMessages] = useState([])
  const { selectedDate, setSelectedDate } = useContext(DatePickerContext)
  const { spinning, setSpinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)

  const fetchMwImportData = () => {
    setSpinning(true)
    getGHWPImport(apiTargetInfo)({
      date: moment(selectedDate).format('YYYY-MM-DD'),
      year: selectedDate.format('YYYY'),
      month: selectedDate.format('MM'),
    }).fork(setError, data => {
      setSpinning(false)
      setMwImportData(data)
    })
  }

  const fileProps = importType => ({
    name: 'file',
    action: `${apiTargetInfo.baseUrl}/interface-data/import-parser`,
    method: 'POST',
    data: { importType },
    headers: getAuthorization(apiTargetInfo),
    ...getCredentials(apiTargetInfo),
  })

  const { authGodMode } = envConfig
  const GridData = useRef()
  const GridContractData = useRef()
  return (
    <div
      css={{
        backgroundColor: '#f0f2f5',
        marginLeft: '20px',
        marginRight: '20px',
      }}
    >
      <CriteriaRow style={{ gridColumnGap: '5px' }}>
        <Title
          css={{
            marginRight: '15px',
            marginBottom: '5px',
            minWidth: '130px',
          }}
        >
          GHWP Import
        </Title>

        <DatePicker.MonthPicker
          allowClear={false}
          format="MMMM-YYYY"
          value={selectedDate}
          onChange={d => {
            setSelectedDate(d.startOf('month'))
          }}
          style={{ minWidth: '200px' }}
        />

        <Button
          loading={spinning}
          onClick={fetchMwImportData}
          css={{ marginLeft: '10px' }}
          type="primary"
          icon="database"
        >
          Retrieve
        </Button>

        <Upload
          {...fileProps('GHWP_10MIN')}
          onChange={data => {
            if (
              data.file.response &&
              data.file.response.restfulStatus &&
              data.file.response.restfulStatus === 'FAILURE'
            ) {
              // setShowMessages(true)
              // setMessages([data.file.response])
              setError(data.file.response)
            } else if (data.file.response && data.file.response.length === 0) {
              //  if (data.file.response) {
              message.success('File imported successfully')
              // }
            } else if (data.file.response && data.file.response.length > 0) {
              setShowMessages(true)
              setMessages(data.file.response)
              //  if (data.file.response) {
              // message.success('File imported successfully')
              // }
            }
          }}
          multiple={false}
          showUploadList={false}
          style={{ marginLeft: '10px' }}
        >
          <Button
            disabled={
              !hasAccesPermits({
                authGodMode,
                actionPermits,
                eventActions: [ScreenPermissions.GHWP_IMPORT_ADMIN],
                matchAny: true,
              })
            }
          >
            <Icon type="upload" /> Import 10Min
          </Button>
        </Upload>

        <Upload
          style={{ marginLeft: '10px' }}
          {...fileProps('GHWP_CONTACT')}
          onChange={data => {
            if (
              data.file.response &&
              data.file.response.restfulStatus &&
              data.file.response.restfulStatus === 'FAILURE'
            ) {
              // setShowMessages(true)
              // setMessages([data.file.response])
              setError(data.file.response)
            } else if (data.file.response && data.file.response.length === 0) {
              //  if (data.file.response) {
              message.success('File imported successfully')
              // }
            } else if (data.file.response && data.file.response.length > 0) {
              setShowMessages(true)
              setMessages(data.file.response)
              //  if (data.file.response) {
              // message.success('File imported successfully')
              // }
            }
          }}
          multiple={false}
          showUploadList={false}
        >
          <Button
            disabled={
              !hasAccesPermits({
                authGodMode,
                actionPermits,
                eventActions: [ScreenPermissions.GHWP_IMPORT_ADMIN],
                matchAny: true,
              })
            }
          >
            <Icon type="upload" /> Import Content
          </Button>
        </Upload>

        <div css={{ flex: '1 1 0px' }} />
        <Input.Search
          placeholder="Filter"
          value={fuzzyFilter}
          css={{ flex: '0 0 150px' }}
          onChange={e => setFuzzyFilter(e.target.value)}
        />
        <ExportComponent
          title="GHWP 10 Min"
          getData={
            exportDataComponent
              ? _ =>
                  exportDataComponent(
                    GridData,
                    mwImportData.ghwp10Min || [],
                    fuzzyFilter
                  )
              : undefined
          }
          data={mwImportData.ghwp10Min || []}
          headers={Ghwp10minImportHeaders}
          fileName={`GHWP 10 Min Import-${selectedDate.format(
            'YYYY-MM-DD HH-mm-ss'
          )}`}
          btnStyle={{ marginRight: '10px' }}
          disabled={(mwImportData.ghwp10Min || []).length <= 0}
        />

        <ExportComponent
          title="GHWP Contact"
          getData={
            exportDataComponent
              ? _ =>
                  exportDataComponent(
                    GridContractData,
                    mwImportData.ghwpContact || [],
                    fuzzyFilter
                  )
              : undefined
          }
          data={mwImportData.ghwpContact || []}
          headers={GhwpContactImportHeaders}
          fileName={`GHWP Contact Import-${selectedDate.format(
            'YYYY-MM-DD HH-mm-ss'
          )}`}
          btnStyle={{ marginRight: '10px' }}
          disabled={(mwImportData.ghwpContact || []).length <= 0}
        />
      </CriteriaRow>
      <FullHeightSizer heightOffset={230}>
        {({ height, width }) => (
          <Content style={{ height: height - 20 }}>
            <Tabs>
              <Tabs.TabPane tab="GHWP 10 Min" title="GHWP 10 Min" key="10min">
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr',
                    height: height - 100 + 'px',
                    width: width - 150 + 'px',
                  }}
                >
                  <Grid
                    ref={GridData}
                    data={mwImportData.ghwp10Min || []}
                    headers={Ghwp10minImportHeaders}
                    altBgColor="#ebebeb"
                    render={virtualizedGridRenderer({
                      autoFixColByKey: false,
                      rowHeaderRender,
                      height: height - 100,
                      width: width - 150,
                      headerRowHeight: 30,
                    })}
                    fuzzyFilter={fuzzyFilter}
                    initialSortOptions={[
                      dateTimeCol({
                        ident: 'pctimestamp',
                        display: 'Pctimestamp',
                        sortOrder: 'asc',
                      }),
                    ]}
                  />
                </div>
              </Tabs.TabPane>
              <Tabs.TabPane
                tab="GHWP Contact"
                title="GHWP Contact"
                key="Contact"
              >
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr',
                    height: height - 100 + 'px',
                    width: width - 150 + 'px',
                  }}
                >
                  <Grid
                    ref={GridContractData}
                    data={mwImportData.ghwpContact || []}
                    headers={GhwpContactImportHeaders}
                    altBgColor="#ebebeb"
                    render={virtualizedGridRenderer({
                      autoFixColByKey: false,
                      rowHeaderRender,
                      height: height - 100,
                      width: width - 150,
                      headerRowHeight: 30,
                    })}
                    fuzzyFilter={fuzzyFilter}
                    initialSortOptions={[
                      dateTimeCol({
                        ident: 'pctimestamp',
                        display: 'Pctimestamp',
                        sortOrder: 'asc',
                      }),
                    ]}
                  />
                </div>
              </Tabs.TabPane>
            </Tabs>
          </Content>
        )}
      </FullHeightSizer>
      {showMessages && (
        <JcTmpErrorDialog
          errors={messages}
          visible={showMessages}
          closeErrorPrompt={_ => setShowMessages(false)}
          title="Error/Warning"
        />
      )}
    </div>
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
})

export default connect(mapStateToProps)(GHWPImport)
